import React from 'react'

const AboutPage = () => {
    return (
      <div>
            <header class="mastHead">
        <p class="mastHeadIntro">Hi, I’m</p>
        <h1 class="mastHeadHeading">WESLEY!</h1>
        </header>
        <section class="introduction-section">
          <h2>Introduction</h2>
          <p>I always loved the Internet.  It’s a place that brings people together, destroys barriers, levels the playing field, and lifts all.  It’s a place of beautiful colors and shapes where people can share their life, their work, and their love.</p>
        </section>
        <section class="location-section">
          <h2>Where I'm From</h2>
          <p>I’m from Cleveland Ohio. I am currently the marketing director at Twin Oaks Media, I oversee all things inbound. I use my problem solving skills on a daily basis creating unique strategies for clients to succeed in their marketing program.</p>
          <p>After graduating from Cleveland State University, I started a small but successful carpet cleaning company, KB Clean. Early on, I learned the difficulties of running a small business in today’s economy. These lessons led me back to my true love of Web design and inbound marketing.</p>
        </section>
        <section class="questions-section">
          <h2>More About Me</h2>
          <p>I love helping other business owners grow their companies. Probably because I know how hard it is. Being there for your kids scraped knees and first loves is hard for any father but especially hard for someone who is trying to build a business from the ground up.  That’s why I love to meet with young entrepreneurs to share with them the lessons I have learned, in order to help expedite their company growth and help them spend as much time as possible with those that really matter, their family.</p>
          <p>Beyond the day-to-day, you will find me hiking, backpacking, watching the latest sci-fi movie, or just spending time with my wife, Katie, and two children, Sophia and Noah.</p>
        </section>
        <footer>
        <p>Say hi to me on these social networks:</p>
        <ul>
          <li><a href="https://github.com/swesleybrown" target="_blank">Github</a></li>
          <li><a href="https://twitter.com/swesleybrown" target="_blank">Twitter</a></li>
          <li><a href="https://plus.google.com/+WesleyBrownDEV" target="_blank">Google+</a></li>
        </ul>
        <p>Cover Image via <a href="http://unsplash.com" target="_blank">Unsplash</a></p>
            </footer>
            </div>

  )
}

export default AboutPage